// Generated by scripts/generate-connector-marks.ts — do not edit by hand.
//
// Every connector mark in `shared/assets/connectors`, keyed by the slug it
// arrives under, so web draws the same set as the other client. Adding an
// `.svg` there and re-running the script is the whole of adding a mark.

import type { FunctionComponent, SVGProps } from "react";

import AffinityMark from "@/assets/connectors/affinity.svg?react";
import AirtableMark from "@/assets/connectors/airtable.svg?react";
import AtlassianMark from "@/assets/connectors/atlassian.svg?react";
import AttioMark from "@/assets/connectors/attio.svg?react";
import BrexMark from "@/assets/connectors/brex.svg?react";
import CodaMark from "@/assets/connectors/coda.svg?react";
import CoinbaseMark from "@/assets/connectors/coinbase.svg?react";
import DeviceMark from "@/assets/connectors/device.svg?react";
import FlightpointsMark from "@/assets/connectors/flightpoints.svg?react";
import GithubMark from "@/assets/connectors/github.svg?react";
import GmailMark from "@/assets/connectors/gmail.svg?react";
import GoogleMark from "@/assets/connectors/google.svg?react";
import GoogleCalendarMark from "@/assets/connectors/google-calendar.svg?react";
import GoogleDocsMark from "@/assets/connectors/google-docs.svg?react";
import GoogleDriveMark from "@/assets/connectors/google-drive.svg?react";
import GoogleSheetMark from "@/assets/connectors/google-sheet.svg?react";
import GoogleSlidesMark from "@/assets/connectors/google-slides.svg?react";
import GoogleTasksMark from "@/assets/connectors/google-tasks.svg?react";
import GranolaMark from "@/assets/connectors/granola.svg?react";
import HarmonicMark from "@/assets/connectors/harmonic.svg?react";
import KiwiMark from "@/assets/connectors/kiwi.svg?react";
import LinearMark from "@/assets/connectors/linear.svg?react";
import MicrosoftExcelMark from "@/assets/connectors/microsoft-excel.svg?react";
import MicrosoftOnedriveMark from "@/assets/connectors/microsoft-onedrive.svg?react";
import MicrosoftPowerpointMark from "@/assets/connectors/microsoft-powerpoint.svg?react";
import MicrosoftTeamsMark from "@/assets/connectors/microsoft-teams.svg?react";
import MicrosoftWordMark from "@/assets/connectors/microsoft-word.svg?react";
import NotionMark from "@/assets/connectors/notion.svg?react";
import OutlookMark from "@/assets/connectors/outlook.svg?react";
import PerplexityMark from "@/assets/connectors/perplexity.svg?react";
import RampMark from "@/assets/connectors/ramp.svg?react";
import RocketreachMark from "@/assets/connectors/rocketreach.svg?react";
import ShopifyMark from "@/assets/connectors/shopify.svg?react";
import SlackMark from "@/assets/connectors/slack.svg?react";
import StripeMark from "@/assets/connectors/stripe.svg?react";
import SupabaseMark from "@/assets/connectors/supabase.svg?react";
import TextMessagesMark from "@/assets/connectors/text-messages.svg?react";
import TodoistMark from "@/assets/connectors/todoist.svg?react";
import WhatsappMark from "@/assets/connectors/whatsapp.svg?react";
import YoutubeMark from "@/assets/connectors/youtube.svg?react";
import ZapierMark from "@/assets/connectors/zapier.svg?react";
import ZoomMark from "@/assets/connectors/zoom.svg?react";

export const sharedConnectorMarks: Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
  affinity: AffinityMark,
  airtable: AirtableMark,
  atlassian: AtlassianMark,
  attio: AttioMark,
  brex: BrexMark,
  coda: CodaMark,
  coinbase: CoinbaseMark,
  device: DeviceMark,
  flightpoints: FlightpointsMark,
  github: GithubMark,
  gmail: GmailMark,
  google: GoogleMark,
  "google-calendar": GoogleCalendarMark,
  "google-docs": GoogleDocsMark,
  "google-drive": GoogleDriveMark,
  "google-sheet": GoogleSheetMark,
  "google-slides": GoogleSlidesMark,
  "google-tasks": GoogleTasksMark,
  granola: GranolaMark,
  harmonic: HarmonicMark,
  kiwi: KiwiMark,
  linear: LinearMark,
  "microsoft-excel": MicrosoftExcelMark,
  "microsoft-onedrive": MicrosoftOnedriveMark,
  "microsoft-powerpoint": MicrosoftPowerpointMark,
  "microsoft-teams": MicrosoftTeamsMark,
  "microsoft-word": MicrosoftWordMark,
  notion: NotionMark,
  outlook: OutlookMark,
  perplexity: PerplexityMark,
  ramp: RampMark,
  rocketreach: RocketreachMark,
  shopify: ShopifyMark,
  slack: SlackMark,
  stripe: StripeMark,
  supabase: SupabaseMark,
  "text-messages": TextMessagesMark,
  todoist: TodoistMark,
  whatsapp: WhatsappMark,
  youtube: YoutubeMark,
  zapier: ZapierMark,
  zoom: ZoomMark,
};
